module.exports = {
    familyData: () => {
        return[
            {
                "FAMILIAS":[
                    {
                        "Nombre":"HB20"
                    },
                    {
                        "Nombre":"HB20S"
                    },
                    {
                        "Nombre":"TUCSON"
                    },
                    {
                        "Nombre":"KONA"
                    },
                    /*{
                        "Nombre":"VENUE"
                    },*/
                    {
                        "Nombre":"STARIA"
                    }
                ]
            }
        ]
    }
}